<script lang="ts">
import { defineComponent } from 'vue';
import CmsPage from '@/components/cms/cms-page.vue';
import ImportantOXSLinks from '@/components/util/important-oxs-links.vue';
import ImportantRDBLinks from '@/components/util/important-rdb-links.vue';

export default defineComponent({
	name: 'HomeView',
	components: {
		CmsPage,
		ImportantOXSLinks,
		ImportantRDBLinks,
	},
	computed: {
		website() {
			return this.$globalStore.websiteStore.websiteCode;
		},
		usageHomepage() {
			return `${this.website.toLowerCase()}-home`;
		},
	},
	methods: {},
	mounted() {
		this.$globalStore.offerSearchStore.resetAllFilters();
		this.$globalStore.requestInit.requestType = '';
	}
});
</script>

<template>
	<el-alert
		type="error"
		:closable="false"
		v-if="!$globalStore.tokenStore.isAgrAccountActive"
		style="margin-bottom: 1.5rem;"
	>
		<h4>{{ $t('default.accountInactive') }}</h4>
	</el-alert>
	<el-container>
		<div>
			<ImportantOXSLinks v-if="website === 'OXS'" />
			<ImportantRDBLinks v-if="website === 'RDB'" />
			<div class="container">
				<CmsPage
					:usage="usageHomepage"
				/>
			</div>
		</div>
	</el-container>
</template>
